import { type ReactNode } from 'react';

import { Tooltip } from '../../../../components/tooltip';

export function ItemTooltip(props: {
  children: ReactNode;
  text: string;
  renderAsTooltip?: boolean;
}) {
  const { children, text, renderAsTooltip = true } = props;
  if (!renderAsTooltip) {
    return children;
  }
  return (
    <Tooltip text={text} className="z-50">
      {children}
    </Tooltip>
  );
}
